module.exports = __webpack_public_path__ + "media/bootstrap-icons/caret-left-square-fill-490d276e.svg";